import React from 'react';
import { Box, Row, Col, Text } from 'tailwind-react-ui';

const MeetSixtyniteSection = () =>{
    return(
        <Box id="conoce-sixtynite" bg={'white'}>
            <Box className="landing-container pb-0 md:pb-16">
                <Row text={'dark-gray'}>
                    <Col p={1} className="w-full sm:w-full md:w-5/12 lg:w-5/12">
                        <Text 
                        is="h3" 
                        className="quicksand-bold sm:text-center md:text-left"
                        leading={'none'} 
                        tracking={'wide'}
                        text={['center','4xl']}>
                            Conoce a <Text 
                            is="a" 
                            className="focus:shadow-none"
                            target="_blank" 
                            rel="noopener noreferrer" 
                            href="https://sixtynite.com/" 
                            leading={'none'} 
                            underline 
                            text={['dark-purple']}>
                                 Sixtynite
                            </Text>
                        </Text>
                        <Text 
                        is="p" 
                        className="quicksand-regular sm:text-center md:text-left" 
                        tracking={'wide'}
                        text={['center', 'xl']}
                        m={{t: 6}}>
                            La App para encontrar y reservar los mejores Moteles.
                        </Text>
                        <Box className="mx-auto mt-2 md:ml-0" style={{maxWidth: '177px'}}>
                            <a href="https://play.google.com/store/apps/details?id=mx.kea.sixtynite" 
                            target="_blank" 
                            rel="noopener noreferrer">
                                <img 
                                src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/googleplay.png" 
                                alt="googleplay-sixtynite"
                                className="mt-4"/>
                            </a>
                            <a href="https://apps.apple.com/app/apple-store/id978458597?pt=117704426&ct=landing-chelas-gratis&mt=8" 
                            target="_blank" 
                            rel="noopener noreferrer">
                                <img 
                                src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/appstore.png" 
                                alt="playstore-sixtynite"
                                className="mt-4"/>
                            </a>
                            <a href="https://wap3.hispace.hicloud.com/uowap/index.jsp#/detailApp/C101700143"
                            target="_blank" 
                            rel="noopener noreferrer">
                                <img 
                                src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/appgallery.png" 
                                alt="ppgallery-sixtynite"
                                className="mt-4"/>
                            </a>
                        </Box>
                    </Col>
                    <Col className="md:w-7/12" w={'0'} p={1}>
                        <img 
                        src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/sixtynite-aplicacion.png" 
                        alt="la-app-para-encontrar moteles"
                        style={{margin: 'auto'}}
                        />
                    </Col>
                </Row>
            </Box>
            <Box className="md:hidden" m={{ t: 8, b: 16 }}>
                <img 
                src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/sixtynite-aplicacion-mobile.png" 
                alt="la-app-para-encontrar moteles"
                style={{width: '100%'}}
                />
            </Box>
        </Box>
    );
}

export default MeetSixtyniteSection;